module.exports = __webpack_public_path__ + "media/images/front/db_live_20190216-e7fab1ee4a54a1f9923d99ecc3ac580f.png";